import { atom } from "nanostores";

export const showGallery = atom(false);
export const showEvents = atom(false);

export const showOverview = atom(false);
